import React from "react";
import Select from "react-select";
import { useGetContractCompanyListQuery } from "@/redux/contractCompanyApi";

export const FormEmployees = ({ formData, handleChange, setFormData }) => {
    const { data: contractCompanyData } = useGetContractCompanyListQuery();

    const contractCompanyOptions =
        contractCompanyData && contractCompanyData.data
            ? contractCompanyData.data.map((item) => ({
                value: item.id,
                label: item.name,
            }))
            : [];

    return (
        <>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>소속 회사</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <Select
                            className="custom-select"
                            classNamePrefix="custom-select"
                            options={contractCompanyOptions}
                            isSearchable
                            placeholder="소속 회사"
                            value={contractCompanyOptions?.find(
                                (opt) => opt.value === formData?.member?.contractPartnerInfo?.contractCompanyId
                            )}
                            onChange={(option) => {
                                setFormData((prev) => ({
                                    ...prev,
                                    member: {
                                        ...prev.member,
                                        contractPartnerInfo: {
                                            ...prev.member.contractPartnerInfo,
                                            contractCompanyId: option,
                                        },
                                    },
                                }));
                            }}
                            instanceId="company-select"
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>근무지명</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.contractPartnerInfo.workLocationName"
                            placeholder="근무지명"
                            value={formData?.member?.contractPartnerInfo?.workLocationName}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
            <div className="item-row" data-grow="3">
                <div className="row-head">
                    <span>직함</span>
                </div>
                <div className="row-content">
                    <div className="form-element">
                        <input
                            type="text"
                            name="member.contractPartnerInfo.position"
                            placeholder="직함"
                            value={formData?.member?.contractPartnerInfo?.position}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
